import React from 'react'
import { SVGIconProps } from '../types'
const SvgMoff = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M12.667 7.333h-1.134c0 .494-.106.954-.286 1.367l.82.82a4.4 4.4 0 0 0 .6-2.187m-2.68.114c0-.04.013-.074.013-.114v-4c0-1.106-.893-2-2-2s-2 .894-2 2v.12zM2.847 2 2 2.847l4.007 4.006v.48c0 1.107.886 2 1.993 2q.222-.002.433-.053l1.107 1.107c-.473.22-1 .346-1.54.346-1.84 0-3.533-1.4-3.533-3.4H3.333c0 2.274 1.814 4.154 4 4.48V14h1.334v-2.187c.606-.086 1.18-.3 1.693-.6L13.153 14l.847-.847z"
      />
    </g>
  </svg>
)
export default SvgMoff
